export function getPrefixNumberFromString(value: string) {
  const match = value.match(/\d+/);
  return match ? match[0] : null;
}
